/*eslint-disable */
import axios from "axios"

const PagareService = {
  getPagaresPenddingVerification(queryParam: $TSMigrationFixMe) {
    return axios.get(`/Pagare/pendientes-aceptacion/${queryParam}`)
  },
  getPdfById(id: $TSMigrationFixMe) {
    return axios.get(`/Pagare/${id}/fichero`, {
      responseType: "blob",
    })
  },
  getPagaresAceptables(queryParam: $TSMigrationFixMe) {
    return axios.get(`/Pagare/aceptables/${queryParam}`)
  },
  IsEmpresaActivaHasPagareToAuthorize(queryParam = "") {
    return axios.get(`/Pagare/any/${queryParam}`)
  },
  getPagareEstadoVerifiacionActualizado() {
    return axios.get("/Pagare/any-estado-verificacion-actualizado")
  },
}

export default PagareService
